import script from "./ProxyLoginFields.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxyLoginFields.vue?vue&type=script&setup=true&lang=js"

import "./ProxyLoginFields.vue?vue&type=style&index=0&id=5de32d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de32d60"]])

export default __exports__